import { render } from "./IconFuture.vue?vue&type=template&id=1b22942e"
import script from "./IconFuture.vue?vue&type=script&lang=js"
export * from "./IconFuture.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__